import type { GridColDef } from '@shared/components';

export enum UserStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  INVITATION_PENDING = 'INVITATION_PENDING',
}

export enum UserListVariants {
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  QBANK_STRUCTURE_MEMBERS = 'QBANK_STRUCTURE_MEMBERS',
}

export enum UserListParamsVariants {
  SEARCH_QUERY_PARAMS = 'SEARCH_QUERY_PARAMS',
  COMPONENT_STATE_PARAMS = 'COMPONENT_STATE_PARAMS',
}

export interface UserAvatarData {
  firstName?: string;
  lastName?: string;
  email?: string;
  profilePic?: string;
}

export interface UserRow {
  userId: string;
  profile: {
    firstName: string;
    lastName: string;
    email: string;
    profilePic: string;
  };
  appRoles: string[];
  lastLoginAt: string;
  invitationExpireAt?: Date | string | null;
  status: UserStatus;
}
export type UserListDefColumn = GridColDef<UserRow>;

interface HideColumnsBase {
  profile: boolean;
  appRoles: boolean;
  lastLoginAt: boolean;
  status: boolean;
}

export type HideColumns = Partial<HideColumnsBase>;

export interface UserListOptions {
  withSearch?: boolean;
  withStatusFilter?: boolean;
  withAppRoleFilter?: boolean;
  withForm?: boolean;
  withSearchBoxFullWidth?: boolean;
  withSelectCountText?: boolean;
}

export interface OnSelectUserCallback {
  (callback: (prev: UserRow[]) => UserRow[]): void | (() => void);
}
